import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Grid, TextField, Button, Divider,MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import api from '../../Services/api';
import {Add,Remove} from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';


const statesInIndia = [
    'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh',
    'Jharkhand','Karnataka', 'Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland',
    'Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal',
    'Andaman and Nicobar Islands','Chandigarh','Dadra and Nagar Haveli and Daman and Diu','Delhi','Ladakh','Lakshadweep','Puducherry'
  ];


export const CorporateProfile = () => {
    let data1 = sessionStorage.getItem('user');
let Data = JSON.parse(data1);
let id = Data.id;

    const [editMode, setEditMode] = useState(false);
      const [snackbarOpen, setSnackbarOpen] = useState(false);
          const [snackbarMessage, setSnackbarMessage] = useState('');
          const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
          const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
            const [errors, setErrors] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [corporateData, setCorporateData] = useState({ 
    CorporateName: '',
    CorporatePhone: '',
    CorporatePhone1: '',
    CorporateEmail: '',
    CorporateEmail1: '',
    CorporateAddress: '',
    CorporateState: '',
    
   
    type:"corporate"
 
       

  });
  const [extraEmailCorporateVisible, setExtraEmailCorporateVisible] = useState(false);
      const [extraPhoneNumberCorporateVisible, setExtraPhoneNumberCorporateVisible] = useState(false);
  

const validateForm = () => {
    const newErrors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^[6789]\d{9}$/;
    
    if (!corporateData.CorporateName) newErrors.CorporateName = 'Company Name is required';
    if (!corporateData.CorporateAddress) newErrors.CorporateAddress = 'Address is required';
    if (!emailPattern.test(corporateData.CorporateEmail)) {
        newErrors.CorporateEmail = corporateData.CorporateEmail
          ? 'Invalid email address (ex: text@email.com)'
          : 'Email address required';
      }



      if (!corporateData.CorporatePhone) {
        newErrors.CorporatePhone = 'Phone number required';
      } else {
      
        const phonePattern = /^[6-9]\d{9}$/;
        if (!phonePattern.test(corporateData.CorporatePhone)) {
          newErrors.CorporatePhone = 'Invalid phone number, Number should not start with zero(6-9)';
        }
        
        const phoneNumber = String(corporateData.CorporatePhone);
        if (phoneNumber.length !== 10 || !/^\d{10}$/.test(phoneNumber)) {
          newErrors.CorporatePhone = 'Phone number should be exactly 10 digits';
        }
      }


      if (corporateData.CorporateEmail1 && !emailPattern.test(corporateData.CorporateEmail1)) {
        newErrors.CorporateEmail1 = 'Invalid email address (e.g., text@email.com)';
      }
     
      if (corporateData.CorporatePhone1 && !phonePattern.test(corporateData.CorporatePhone1)) {
        newErrors.CorporatePhone1 = 'Invalid phone number. Number should not start with zero(6-9) and length should be 10';
      }
      const selectField = corporateData.CorporateState;
      if (!selectField) {
        newErrors.selectField = 'Please select state';
      }
      setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
}
  useEffect(() =>{
    api.Corporate.getCoporateProfileDetails(id)
    .then(response =>{
      const temp = response.data.data;
      console.log("temp",temp);
      setCorporateData(temp);
      
      setOriginalData(temp);
    })
    .catch(error => console.error('error fetching profile data:', error))
  }, []);

  



 

  const handleEdit = () => {
    setOriginalData({...corporateData});
    setEditMode(true);
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setCorporateData({...originalData});
    setErrors({})
   
  };

  const handleAddPhoneNumberCorporateField = () => {
    setExtraPhoneNumberCorporateVisible(prevState =>!prevState);
  };
  const handleAddEmailCorporateField = () => {
    setExtraEmailCorporateVisible(prevState => !prevState);
  };
 
  const handleSave = async()=>{
    const isDataChanged = JSON.stringify(corporateData) !== JSON.stringify(originalData);

    if (!isDataChanged) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("No changes detected");
      setEditMode(true); 
      return; 
    }
    if(validateForm()){
        
        try{
  const response = await api.Corporate.updateCorporateProfile( id , corporateData)
  
      if(response.status === 200){
setSnackbarOpen(true)
setSnackbarMessage(response.data.message)
      setOriginalData({ ...corporateData });
      setEditMode(false)
    }
    else if(response.status === 400){
     setSnackbarOpen(true);
     setErrorSnackbarOpen(response.data.message)
    }
    else if(response.status === 500){
        setSnackbarOpen(true);
        setErrorSnackbarOpen(response.data.message)
       }
       else {
        setSnackbarOpen(true);
        setErrorSnackbarOpen('Error in updating, try again')
        setEditMode(false)
       }
    }

    catch(error) {
        setErrorSnackbarOpen(true);
     setSnackbarErrorMessage("Error Occured while updating")
    };
}
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCorporateData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  return (
    <>
      <Snackbar
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      
                      }}
                      severity="success"
                      open={snackbarOpen}
                      autoHideDuration={2000}
                      onClose={() => setSnackbarOpen(false)}
                      sx={{
                        marginTop: '2.9%', 
                        marginRight: '7%'
                      }}
                    >
                      <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                    </Snackbar>
                    <Snackbar
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      severity="error"
                      open={errorSnackbarOpen}
                      autoHideDuration={2000}
                      sx={{
                        marginTop: '2.9%', 
                        marginRight: '7%'
                      }}
                      onClose={() => {setErrorSnackbarOpen(false)}}
                    >
                      <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                    </Snackbar>
    <div className="mt-3 d-flex justify-content-center align-items-center">
  <Card>
    <h5 className="text-light bg-dark p-2" style={{border:'1px solid lightgray'}}>{corporateData.CorporateName}</h5>
    <section className="d-flex flex-col">
    
      <div className="p-4">
      {/* <h5 className="text-center text-light w-100" style={{borderBottom:'1px solid lightgray'}}>Conatct Person Details</h5> */}
        <div>
           <Typography variant="body3" className="mt-1 text-dark" component="div">
{editMode ? (
              <TextField
                type="text"
                name="CorporateName"
                value={corporateData?.CorporateName}
                placeholder='Enter Corporate Name'
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                 error={!!errors.CorporateName}
                helperText={errors.CorporateName}
              />
            ) : (
          <></>
            )}
          </Typography> 
           <Typography variant="body3" className="mt-1 text-dark" component="div">
          {editMode ? (
           <FormControl  margin="normal">
             
                <Select
                  name="CorporateState"
                  value={corporateData.CorporateState}
                  onChange={handleInputChange}
                  placeholder='Select State'
                  error={!!errors.CorporateState}
                  size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                >
                  {statesInIndia.map((state, index) => (
                    <MenuItem key={index} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
           
          ) : (
           <p>State: {corporateData.CorporateState}</p>
          )}
           {errors.stateId && (
    <div className="pb-3 px-5" style={{ color: 'red', fontSize: '14px' }}>
      {errors.stateId}
    </div>
  )}
          </Typography>
           <Typography variant="body3" className="mt-1 text-dark" component="div">
           {editMode ? (
              <TextField
                type="text"
                name="CorporateAddress"
                value={corporateData?.CorporateAddress}
                placeholder='Enter Address'
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.CorporateAddress}
                helperText={errors.CorporateAddress}
              />
            ) : (
             <p> Address: {corporateData?.CorporateAddress}</p>
            )}
          </Typography> 
  
          <Typography variant="body3" className="mt-2 text-dark d-flex" component="div">
      
            {editMode ? (
              <TextField
                type="text"
                name="CorporatePhone"
                value={corporateData.CorporatePhone}
                placeholder="Enter Phone Number"
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.CorporatePhone}
                helperText={errors.CorporatePhone}
              />
            ) : (
             <p>Contact Number: {corporateData.CorporatePhone}</p>
            )}

              <IconButton onClick={handleAddPhoneNumberCorporateField} color="primary">
              {extraPhoneNumberCorporateVisible ? <Remove sx={{ color: "gray",fontSize:'16px' }} /> : <Add sx={{ color: "gray",fontSize:'16px' }} />}
          </IconButton>
          </Typography>
 {extraPhoneNumberCorporateVisible && (
  
  <Typography variant="body3" className=" mt-1 text-dark" component="div">
                      {editMode ? (
              <TextField
                type="text"
                name="CorporatePhone1"
                value={corporateData?.CorporatePhone1}
                onChange={handleInputChange}
                placeholder='Enter Alternative Phone Number'
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.CorporatePhone1}
                helperText={errors.CorporatePhone1}
              />
            ) : (
              <p>Alternative Number: {corporateData?.CorporatePhone1}</p>
            )}
                    </Typography>
                  )}

  
          <Typography variant="body3" className="mt-2 text-dark d-flex" component="div">
       
            {editMode ?  (
             
         
             <TextField
                type="text"
                name="CorporateEmail"
                value={corporateData.CorporateEmail}
                placeholder="Enter Email"
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.CorporateEmail}
                helperText={errors.CorporateEmail}
              />
            ) : (
              <p>Email: {corporateData.CorporateEmail}</p>
            )}
             <IconButton onClick={handleAddEmailCorporateField}  color="primary">
            {extraEmailCorporateVisible ? <Remove sx={{ color: "gray",fontSize:'16px'  }} /> : <Add sx={{ color: "gray" ,fontSize:'16px' }} />}
          </IconButton> 
 </Typography>

           {extraEmailCorporateVisible && (
            
            <Typography variant="body3" className=" mt-1 text-dark" component="div">
                                {editMode ? (
                        <TextField
                          type="text"
                          name="CorporateEmail1"
                          placeholder='Enter Alternative Email'
                          value={corporateData?.CorporateEmail1}
                          onChange={handleInputChange}
                          variant="outlined"
                          size="small"
                          inputProps={{ style: { color: '#000000' } }}
                          style={{ backgroundColor: "white" }}
                          error={!!errors.CorporateEmail1}
                          helperText={errors.CorporateEmail1}
                        />
                      ) : (
                       <p>Alternative Email: {corporateData?.CorporateEmail1}</p>
                      )}
                              </Typography>
                            )}
         
        </div>
  
        {/* Edit and Save Buttons */}
        {editMode ? (
          <div className="mt-3 pb-3 text-center">
            <button onClick={handleCancelEdit} className="mx-3 btn btn-sm btn-danger">
              Cancel
            </button>
            <button onClick={handleSave} className="mx-2 btn btn-sm btn-success" disabled={!validateForm}>
              Save
            </button>
          </div>
        ) : (
          <div className='mt-2 d-flex float-end'>  
            <button onClick={handleEdit} className="btn btn-sm btn-danger text-light">
           Edit
            </button>
          </div>
        )}
      </div>
    </section>
  </Card>
</div>
</>

  )
}
